import React from 'react';
function Icon(props) {
  if (props?.size == 'sm') {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 -960 960 960">
        <path fill={props.fill || '#1D252D'} d="M709.23-164H257.08v-440l273.38-271.84L546.3-870q17.24 12.23 25.35 30.5 8.12 18.27 3.12 37.35V-806L538.3-604h289.39q26.54 0 45.42 18.89Q892-566.23 892-539.69v41.61q0 7.23-1.31 12.96t-3.92 11.97L773.15-205.69q-8.61 19.23-25.84 30.46T709.23-164M205.08-604v440H68v-440z"></path>
      </svg>;
  }
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e8eaed" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M709.23-140H313.08v-480l265.38-263.84L612.3-850q6.24 6.23 10.35 16.5 4.12 10.27 4.12 19.35V-804L584.3-620h243.39q28.54 0 50.42 21.89Q900-576.23 900-547.69v64.61q0 6.23-1.31 13.46t-3.92 13.47L780.15-185.69q-8.61 19.23-28.84 32.46T709.23-140zM253.08-620v480H100v-480h153.08z"></path>
    </svg>;
}
export default Icon;